// extracted by mini-css-extract-plugin
module.exports = {"rootDiv":"eyebrowLabel_rootDiv__2Ttzd"};